/****************************************************
 * 2) VPS Assembler
 *    Gathers resources (CPU-RAM-STORAGE-bandwidth), addon IDs, plan, etc.
 *    Creates addons array (BGP-OS-ADDITIONALIP by passing the configuration to extractAddonsId
 *    FILTER(BOOLEAN) is used to remove falsy values (undefined, null, etc) so they dont get sent to the endpoint
 ****************************************************/
export function assembleVpsPayload(configuration, selectedPlan) {
	//debugger;
	return {
		// VPS specific resources:
		resources: [
			selectedPlan.cpu?.id,
			selectedPlan.ram?.id,
			selectedPlan.storage?.id,
			selectedPlan.bandwidth?.id,
			selectedPlan.transfer?.id,
		].filter(Boolean),

		// VPS addons IDs (array)
		addons: [configuration.bgp?.id, configuration.additionalIp?.id, configuration.os?.id].filter(Boolean),
		// VPS server name (string)
		hostname: configuration.serverName,
	};
}

/****************************************************
 * 2) Baremetal Assembler
 *    Gathers resources (CPU-RAM-STORAGE-bandwidth)
 *    Creates addons array (BGP-OS-ADDITIONALIP by passing the configuration to extractAddonsId
 *    FILTER(BOOLEAN) is used to remove falsy values (undefined, null, etc) so they dont get sent to the endpoint
 ****************************************************/
export function assembleBaremetalPayload(configuration, selectedPlan) {
	//debugger;
	return {
		// Baremetal specific resources:
		resources: [
			selectedPlan.cpu?.id,
			selectedPlan.ram?.id,
			selectedPlan.storage?.id,
			selectedPlan.bandwidth?.id,
			selectedPlan.transfer?.id,
		].filter(Boolean),

		// BAREMETAL addons IDs (optional)
		addons: [configuration.bgp?.id, configuration.additionalIp?.id, configuration.os?.id].filter(Boolean),
		// BAREMETAL server name
		hostname: configuration.serverName,
	};
}

/****************************************************
 * 4) Colocation Payload Assembler
 *    Gathers resources (RACK-ENERGY-bandwidth-PREFIX)
 *    COLO has no addons, when addons are added, they have to be added here
 *    COLO has no plans, when plans are added, they have to be added here
 ****************************************************/
export function assembleColocationPayload(configuration, selectedPlan) {
	return {
		// Extract COLOCATION specific resources:
		addons: [configuration.bgp?.id].filter(Boolean),
		resources: [
			selectedPlan.rack?.id,
			selectedPlan.energy?.id,
			selectedPlan.bandwidth?.id,
			selectedPlan.prefix?.id,
		].filter(Boolean),
	};
}

/****************************************************
 *    Ultraproxy Payload Assembler
 *    Creates ultraproxies array with selectedCountry : (Example: "ultraproxies": ["mia"],)
 ****************************************************/
export function assembleUltraproxyPayload(selectedLocation) {
	//debugger;
	return {
		ultraproxies: [selectedLocation.iata_code],
	};
}

/****************************************************
 *    BGP Payload Assembler
 ****************************************************/
export function assembleBgpPayload(selectedLocation) {
	// debugger;
	return {
		bgps: [selectedLocation.iata_code],
	};
}

/****************************************************
 *    IPTransit Payload Assembler
 ****************************************************/
export function assembleIpTransitPayload(selectedPlan) {
	// debugger;
	return {
		resources: [selectedPlan.bandwidth?.id],
	};
}

/****************************************************
 *    Storage Payload Assembler
 *    Creates ultraproxies array with selectedLocation)
 ****************************************************/
export function assembleStoragePayload(selectedPlan) {
	// debugger;
	return {
		resources: [selectedPlan.nas?.id],
	};
}

/****************************************************
 *    Webhosting Payload Assembler
 *    Creates plan array with with id
 ****************************************************/
export function assembleWebhostingPayload(selectedPlan) {
	// debugger;
	return {
		plans: [selectedPlan?.id],
	};
}

/****************************************************
 * 5) Main "buildOrderPayload" function
 *    1) Builds a common payload from Formik values
 *    2) Switches by "service" and merges with
 *       the appropriate assembler function
 ****************************************************/
export function buildOrderPayload(formValues, selectedPlan, currency, selectedLocation, orderCount) {
	// Destructure formik object for payload creation.
	const { configuration, service } = formValues;

	// Common fields for all services. All payloads share these fields
	const commonPayload = {
		profileId: configuration.paymentProfile.id,
		currency: currency,
		cycle: configuration.paymentCycle,
		paymentMethod: configuration.paymentMethod.module,
		hostname: configuration.serverName,
		count: orderCount,
	};

	// Switch by "service" to call the right assembler and create the corresponding payload
	switch (service) {
		case "vps":
			return {
				...commonPayload,
				...assembleVpsPayload(configuration, selectedPlan),
			};

		case "baremetal":
			return {
				...commonPayload,
				...assembleBaremetalPayload(configuration, selectedPlan),
			};

		case "colocation":
			return {
				...commonPayload,
				...assembleColocationPayload(configuration, selectedPlan),
			};

		case "ultraproxy":
			return {
				...commonPayload,
				...assembleUltraproxyPayload(selectedLocation),
			};
		case "storage":
			return {
				...commonPayload,
				...assembleStoragePayload(selectedPlan),
			};
		case "bgp":
			return {
				...commonPayload,
				...assembleBgpPayload(selectedLocation),
			};
		case "webhosting":
			return {
				...commonPayload,
				...assembleWebhostingPayload(selectedPlan),
			};
		case "iptransit":
			return {
				...commonPayload,
				...assembleIpTransitPayload(selectedPlan),
			};

		default:
			// If there's a fallback or unknown service / missed service case in this switch
			return { ...commonPayload };
	}
}
